import { defineComponent as _defineComponent } from 'vue'
import { TUIGlobal, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { defineProps, toRefs, defineEmits, ref } from "../../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-input-button',
  props: {
  enableSend: {
    type: Boolean,
    default: true,
  },
},
  emits: ["sendMessage"],
  setup(__props, { emit: emits }) {

const props = __props



const isPC = ref(TUIGlobal.getPlatform() === "pc");

const sendMessage = () => {
  emits("sendMessage");
};

return { __sfc: true,props, emits, isPC, sendMessage, TUITranslateService }
}

})